import { Module } from '@nestjs/common';
import { TypesController } from './types.controller';
import { TypesService } from './types.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Types } from './types.entity';
import { TypesAdapter } from './dto/types.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports:[
    TypeOrmModule.forFeature([Types]),
  ],
  controllers: [TypesController],
  providers: [TypesService,ApplicationExceptionHandler,TypesAdapter,LogsService]
})
export class TypesModule {}